<template>
 <div class="csoportjegyek">
     <v-app id="csoportjegyek">
             <h1>Jegyek</h1>
             <v-tabs grow v-model="jegyekaktivtab">
               <v-tab>
                 Jegyek kategóriánként
               </v-tab>
               <v-tab>
                 Jegyek összegezve
               </v-tab>
               <v-tab-item> <!--jegyek kategóriánként-->
                 <v-select
                   label="Megjelenítendő témakör"
                   :items="csoport.temakorok"
                   item-text="nev"
                   item-value="id"
                   v-model="megjelenitendotemakor"
                 ></v-select>
                   <v-simple-table>
                     <template v-slot:default>
                       <thead>
                         <th class="text-center">Tanuló</th>
                         <th class="text-center">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">Átlag</span>
                             </template>
                             <span>A 0-t teljesített gyakorlatok nincsenek benne</span>
                           </v-tooltip>
                         </th>
                         <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">{{gyakorlat.nev}}</span>
                             </template>
                             <span>{{gyakorlat.leiras}}</span>
                           </v-tooltip>
                         </th>
                       </thead>
                       <tbody>
                         <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                           <td class="text-center"> {{tanulo.nev}} </td>
                           <td class="text-center">
                             <v-tooltip bottom>
                               <template v-slot:activator="{ on }">
                                 <span v-on="on">{{tanulokategoriaatlagkalkulalas(tanulo.id,tanulo.nem==0,megjelenitendotemakor)}}</span>
                               </template>
                               <span>A 0-t teljesített gyakorlatok nincsenek benne</span>
                             </v-tooltip>
                          </td>
                           <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                             <v-tooltip bottom>
                               <template v-slot:activator="{ on }">
                                 <span v-on="on">{{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[0]}}</span>
                               </template>
                               <span>Elvégzett mennyiség: {{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[1]}}</span>
                             </v-tooltip>
                           </td>
                         </tr>
                         <tr>
                           <td class="text-center">ÁTLAG</td>
                           <td class="text-center">
                             <v-tooltip bottom>
                               <template v-slot:activator="{ on }">
                                 <span v-on="on">{{kategoriaatlagkalkulalas(megjelenitendotemakor)}}</span>
                               </template>
                               <span>(A 0-t teljesítettek nincsenek benne)</span>
                             </v-tooltip>
                           </td>
                           <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                             <v-tooltip bottom>
                               <template v-slot:activator="{ on }">
                                 <span v-on="on">{{gyakorlatatlagkalkulalas(gyakorlat.id)}} </span>
                               </template>
                               <span>{{gyakorlat.nev}} (A 0-t teljesítettek nincsenek benne)</span>
                             </v-tooltip>
                           </td>
                         </tr>
                       </tbody>
                     </template>
                   </v-simple-table>
               </v-tab-item> <!--jegyek kategóriánként-->
               <v-tab-item> <!--jegyek összegezve-->
                 <v-simple-table>
                   <template v-slot:default>
                     <thead>
                       <th class="text-center">Tanuló</th>
                       <th class="text-center">
                         <v-tooltip bottom>
                           <template v-slot:activator="{ on }">
                             <span v-on="on">Átlag</span>
                           </template>
                           <span>A 0-t teljesített gyakorlatok nincsenek benne</span>
                         </v-tooltip>
                       </th>
                       <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" >
                         <v-tooltip bottom>
                           <template v-slot:activator="{ on }">
                             <span v-on="on">{{gyakorlat.nev}}</span>
                           </template>
                           <span>{{gyakorlat.leiras}}</span>
                         </v-tooltip>
                       </th>
                     </thead>
                     <tbody>
                       <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                         <td class="text-center"> {{tanulo.nev}} </td>
                         <td class="text-center">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">{{tanulokategoriaatlagkalkulalas(tanulo.id,tanulo.nem==0,"m")}}</span>
                             </template>
                             <span>A 0-t teljesített gyakorlatok nincsenek benne</span>
                           </v-tooltip>
                        </td>
                         <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">{{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[0]}}</span>
                             </template>
                             <span>Elvégzett mennyiség: {{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[1]}}</span>
                           </v-tooltip>
                         </td>
                       </tr>
                       <tr>
                         <td class="text-center">ÁTLAG</td>
                         <td class="text-center">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">{{kategoriaatlagkalkulalas("m")}}</span>
                             </template>
                             <span>(A 0-t teljesítettek nincsenek benne)</span>
                           </v-tooltip>
                         </td>
                         <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <span v-on="on">{{gyakorlatatlagkalkulalas(gyakorlat.id)}}</span>
                             </template>
                             <span>{{gyakorlat.nev}} (A 0-t teljesítettek nincsenek benne)</span>
                           </v-tooltip>
                         </td>
                       </tr>
                     </tbody>
                   </template>
                 </v-simple-table>
               </v-tab-item> <!--jegyek összegezve-->
             </v-tabs> <!--Jegyek-->
       <router-link :to="{ name: 'csoporteredmenybevitel', params: {id: id} }"><v-fab-transition><v-btn color="lime" bottom right fixed fab><v-icon>fa-keyboard</v-icon></v-btn></v-fab-transition></router-link>
       <router-link :to="{ name: 'csoportgyakorlatok', params: {id: id} }"><v-fab-transition><v-btn color="orange" bottom left fixed fab><v-icon>fa-dumbbell</v-icon></v-btn></v-fab-transition></router-link>

     </v-app>
 </div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/


    import router from "../router"

export default {
 props: ['id'],
 components: {
 },
 data: function () {
   return {
     csoport: {},
     jegyekaktivtab: 0,
     megjelenitendotemakor: -1
   }
 },
 computed: {
 ujtanulolany: {
   get: function(){
     return !this.ujtanulofiu;
   },
   set: function(ujertek){
     this.ujtanulofiu=!ujertek
   },
 },
 megjelenitettgyakorlatok: function(){
   var szamlalo=0;
   for(const gyakorlat of this.csoport.gyakorlatok){
     if(gyakorlat.temakor==this.megjelenitendotemakor){
       szamlalo++;
     }
   }
   return szamlalo;
 }
 },
 methods: {
   kijelentkezes: function() {
           this.$store.commit('bejelentkezve', false)
           router.push('/bejelentkezes');
           this.$store.commit('admin',false)
   },
   kategoriaatlagkalkulalas: function(kategoria) {
     var atlagosszeg=0;
     var jegyekszama=0;
       this.csoport.elvegzettgyakorlatok.forEach(elvegzettgyakorlat => {
         if(elvegzettgyakorlat.elvegzettmennyiseg>0 && (kategoria=="m" || this.csoport.gyakorlatok.find(gy => gy.id==elvegzettgyakorlat.gyakorlatid).temakor==kategoria)){
           jegyekszama++;
           atlagosszeg+=this.jegykalkulalas(elvegzettgyakorlat.tanuloid,elvegzettgyakorlat.gyakorlatid,this.csoport.tanulok.find(t => t.id==elvegzettgyakorlat.tanuloid).nem==0)[2];
         }
       })
       return Math.round((atlagosszeg/jegyekszama) * 100) / 100

   },
   gyakorlatatlagkalkulalas: function(gyakorlatid) {
    var atlagosszeg = 0;
    var jegyekszama = 0;
    this.csoport.elvegzettgyakorlatok.filter(elvegzettgyakorlat => elvegzettgyakorlat.gyakorlatid==gyakorlatid).forEach((e) => {
      if(e.elvegzettmennyiseg>0){
        jegyekszama++;
        atlagosszeg+=this.jegykalkulalas(e.tanuloid,e.gyakorlatid,this.csoport.tanulok.find(t => t.id==e.tanuloid).nem==0)[2];
      }
    })
    return Math.round((atlagosszeg/jegyekszama) * 100) / 100
   },
   tanulokategoriaatlagkalkulalas: function(tanuloid, nem,  kategoria) {
     var atlagosszeg = 0;
     var gyakorlatokszama =0;
     this.csoport.gyakorlatok.forEach((e) => {
       if(kategoria=="m" || e.temakor==kategoria){
         gyakorlatokszama++;
         var jegy = this.jegykalkulalas(tanuloid,e.id,nem)[2]
         atlagosszeg+= jegy;
         if(!jegy){
           gyakorlatokszama--;
         }
       }
     })
     if(!isNaN(atlagosszeg/gyakorlatokszama)){
       return Math.round((atlagosszeg/gyakorlatokszama) * 100) / 100/*atlagosszeg/gyakorlatokszama*/;
     }
     else{
       return "";
     }
   },
   jegykalkulalas: function (tanuloid, gyakorlatid, fiu) {
     var gyakorlat = this.csoport.gyakorlatok.find(({ id }) => id === gyakorlatid)
     var elvegzettmennyiseg = this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegindexletrehozas(tanuloid,gyakorlatid)].elvegzettmennyiseg;
     if(fiu){
       if(gyakorlat.novekvo==1){
         if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny5){
           return [5, elvegzettmennyiseg, 5];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny4){
           return [4, elvegzettmennyiseg, 4];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny3){
           return [3, elvegzettmennyiseg, 3];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny2){
           return [2, elvegzettmennyiseg, 2];
         }
         else if(elvegzettmennyiseg>0){
           return [1, elvegzettmennyiseg, 1];
         }
         else{
           return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg, 0];
         }
       }
       else{
         if(elvegzettmennyiseg>gyakorlat.fkovetelmeny2){
           return [1, elvegzettmennyiseg, 1];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny3){
           return [2, elvegzettmennyiseg, 2];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny4){
           return [3, elvegzettmennyiseg, 3];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny5){
           return [4, elvegzettmennyiseg, 4];
         }
         else if(elvegzettmennyiseg>0){
           return [5, elvegzettmennyiseg, 5];
         }
         else{
           return ["0-t teljesített.", elvegzettmennyiseg, 0];
         }
       }
     }
     else{
       if(gyakorlat.novekvo==1){
         if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny5){
           return [5, elvegzettmennyiseg,5];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny4){
           return [4, elvegzettmennyiseg,4];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny3){
           return [3, elvegzettmennyiseg,3];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny2){
           return [2, elvegzettmennyiseg,2];
         }
         else if(elvegzettmennyiseg>0){
           return [1, elvegzettmennyiseg,1];
         }
         else{
           return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg,0];
         }
       }
       else{
         if(elvegzettmennyiseg>gyakorlat.lkovetelmeny2){
           return [1, elvegzettmennyiseg,1];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny3){
           return [2, elvegzettmennyiseg,2];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny4){
           return [3, elvegzettmennyiseg,3];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny5){
           return [4, elvegzettmennyiseg,4];
         }
         else if(elvegzettmennyiseg>0){
           return [5, elvegzettmennyiseg,5];
         }
         else{
           return ["0-t teljesített.", elvegzettmennyiseg,0];
         }
       }

     }
   },

   elvegzettmennyisegindexletrehozas: function(tanulo,gyakorlat) {
     var index= this.elvegzettmennyisegid(tanulo,gyakorlat);
     if(index!=-1){
       return index;
     }
     else{
       this.csoport.elvegzettgyakorlatok.push({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo});
       /*console.log({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo})
       console.log(this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegid(tanulo,gyakorlat)])*/

       return this.elvegzettmennyisegid(tanulo,gyakorlat);
     }
   },
   elvegzettmennyisegszamitas: function (tanulo, gyakorlat) {
     var index = this.elvegzettmennyisegid(tanulo, gyakorlat)
     if (index != -1) {
       return this.csoport.elvegzettgyakorlatok[index].elvegzettmennyiseg
     } else {
       return '0'
     }
   },
   elvegzettmennyisegid: function (tanulo, gyakorlat) {
     var index = this.csoport.elvegzettgyakorlatok.findIndex(elvegzettgyakorlat => {
                 var tanuloOK = elvegzettgyakorlat.tanuloid == tanulo
                 var gyakorlatOK = elvegzettgyakorlat.gyakorlatid == gyakorlat
                 return tanuloOK & gyakorlatOK
               })
     return index
   },
   csoportfrissitese: function () {
     this.axios
       .get(this.$store.state.backendeleres+'csoportok/csoport/' + this.id)
       .then(response => {this.csoport = response.data;
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
           if(response.data.sablon) {
             router.push('/csoportok');
           }
         })
   },
   objektumatadas: function (objektum) {
     return JSON.parse(JSON.stringify(objektum))
   }
 },
 mounted () {
   this.csoportfrissitese()
 }
}
</script>
